import authApi from 'api/auth';
import { useAppDispatch } from 'app/hooks';
import { setBlance } from 'features/home/homeSlice';
import { useState, useEffect } from 'react';
import { setClearStateToLogout } from 'redux/userSlice';
import { getLocalStorage, removeLocalStorage } from 'utils/sessionStorage';
import useUserDetail from './useUserDetail';

const FORCE_LOGOUT_SECONDS: number = Number(
  process.env.REACT_APP_FORCE_LOGOUT_SECONDS || '3600000',
);

const UserInactivityDetector = () => {
  const [isInactive, setIsInactive] = useState(false);
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [timeLeft, setTimeLeft] = useState(FORCE_LOGOUT_SECONDS);
  const dispatch = useAppDispatch();
  const { getUserDetail, isUserLoggedIn } = useUserDetail();

  const onInactive = async () => {
    if (isUserLoggedIn) {
      const accessToken = getLocalStorage('access_token_terabet');
      const { ok, error } = await authApi.logout({
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (ok) {
        dispatch(setClearStateToLogout());
      }
      if (error && error.unauthorized) {
        dispatch(setClearStateToLogout());
      }
      dispatch(setBlance('0'));
      removeLocalStorage('access_token_terabet');
      removeLocalStorage('kyc_access_token_terabet');
      getUserDetail();
    }
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll', 'click'];

    const resetTimer = () => {
      if (isInactive) {
        setIsInactive(false);
      }
      setLastActivity(Date.now());
    };
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    const intervalId = setInterval(() => {
      const currentTime = Date.now();
      const timeSinceLastActivity = currentTime - lastActivity;

      const remaining = Math.max(0, FORCE_LOGOUT_SECONDS - timeSinceLastActivity);
      setTimeLeft(remaining);

      if (timeSinceLastActivity > FORCE_LOGOUT_SECONDS && !isInactive) {
        setIsInactive(true);
        onInactive();
      }
    }, 1000);

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      clearInterval(intervalId);
    };
  }, [isInactive, lastActivity, onInactive, FORCE_LOGOUT_SECONDS]);

  return null;
};

export default UserInactivityDetector;
